<script setup lang="ts">
import { useAppShake } from '~/composables/useAppShake';
import { useGlobalMerchant } from '~/composables/useGlobalMerchant';
import { useSupabaseUser } from '~/composables/useSupabaseUser';
import { getMerchantClientSettingState } from '~~/models/MerchantClientSettings';

const merchant = useGlobalMerchant();
const merchantSlug = computed(() => merchant.value?.slug);
const user = useSupabaseUser();

const { isShaking, stop: stopShaking } = useAppShake();
</script>

<template>
	<div class="min-h-screen flex flex-col">
		<div
			v-if="merchantSlug && !getMerchantClientSettingState(merchantSlug, 'hideMigrationBanner') && !user"
			class="bg-neutral-800 text-white py-4 lg:h-16 flex items-center justify-center"
		>
			<p class="text-base text-center font-bold">
				<span>{{ $t('banner.v1Migration.text') }}</span>
				<NuxtLink
					:to="{ name: 'MerchantSignupMigrate', params: { merchantSlug } }"
					class="underline hover:no-underline ml-1"
				>
					{{ $t('banner.v1Migration.link') }}
				</NuxtLink>
			</p>
		</div>
		<div class="px-8 pt-6 lg:p-0 lg:absolute lg:top-4 lg:right-4 z-50 w-min ml-auto">
			<WidgetLanguageSwitcher />
		</div>
		<UContainer
			class="px-4 sm:px-6 lg:px-14 p-8 flex-1 grid grid-rows-[1fr_auto]"
		>
			<div
				class="lg:grid items-center"
				:class="{
					'animate-shake': isShaking
				}"
				@animationend="stopShaking"
			>
				<slot />
			</div>
			<TheFooter />
			<svg
				class="fixed bottom-0 left-0 z-[-1] hidden lg:block"
				width="404"
				height="404"
				fill="none"
				viewBox="0 0 404 404"
			>
				<defs>
					<pattern
						id="e229dbec-10e9-49ee-8ec3-0286ca089edf"
						x="0"
						y="0"
						width="20"
						height="20"
						patternUnits="userSpaceOnUse"
					>
						<rect
							x="0"
							y="0"
							width="4"
							height="4"
							class="text-neutral-200 dark:text-neutral-800"
							fill="currentColor"
						/>
					</pattern>
				</defs>
				<rect
					width="404"
					height="784"
					fill="url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)"
				/>
			</svg>
		</UContainer>
	</div>
</template>
